import { styled } from '@nykaa/ui-components';
import BaseButton from '@nykaa/ui-components/Button';

export const CouponErrorContainer = styled.div`
  position: static;
  margin-top: 80px;
  width: 100%;
  padding: ${({ theme }) => `0 ${theme.spacing.spacing240}`};
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ImageContainer = styled.div`
  width: 198px;
  margin: auto;
  margin-bottom: ${({ theme }) => theme.spacing.spacing240};
`;

export const Content = styled.div``;

export const Title = styled.div`
  margin: ${({ theme }) => `auto 0 ${theme.spacing.spacing20}`};
  text-align: center;
  ${({ theme }) => theme.typography.titleLarge};
  color: ${({ theme }) => theme.colors.textPrimary};
`;

export const Subtitle = styled.div`
  margin: ${({ theme }) => `auto 0 ${theme.spacing.spacing120}`};
  text-align: center;
  ${({ theme }) => theme.typography.bodyLarge};
  color: ${({ theme }) => theme.colors.textSecondary};
`;

export const ActionButton = styled(BaseButton)`
  height: 48px;
  ${({ theme }) => theme.typography.buttonLarge};
  background-color: ${({ theme }) => theme.colors.textPrimary};
  color: ${({ theme }) => theme.colors.surface};
`;
